export const getDateParam = (date) => encodeURIComponent(date?.split('/').reverse().join('-'))
